var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneCallSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.34 8.25333C10.52 8.25333 9.72667 8.12 8.98667 7.88C8.75333 7.8 8.49333 7.86 8.31333 8.04L7.26667 9.35333C5.38 8.45333 3.61333 6.75333 2.67333 4.8L3.97333 3.69333C4.15333 3.50667 4.20667 3.24667 4.13333 3.01333C3.88667 2.27333 3.76 1.48 3.76 0.66C3.76 0.3 3.46 0 3.1 0H0.793333C0.433333 0 0 0.16 0 0.66C0 6.85333 5.15333 12 11.34 12C11.8133 12 12 11.58 12 11.2133V8.91333C12 8.55333 11.7 8.25333 11.34 8.25333Z",
  fill: "#636766"
})));
export { SvgPhoneCallSvg as ReactComponent };
export default __webpack_public_path__ + "9df6067c1defb28fb83c891258d77c55.svg";